import { Stack } from "@mui/material";
import WcAutoComplete from "../WcAutoComplete/WcAutoComplete";
import WcTextField from "../WcTextfield/WcTextField";
import React from "react";
import { SxProps, Theme } from "@mui/material";

export interface WcMultiTagProps {
  inputValue?: string[];
  label: string;
  maxHeight?: string | number;
  tagOptions: any[];
  disableCloseOnSelect: boolean;
  onTagValueChange: (value: string[] | any[]) => void;
  sx?: SxProps<Theme>;
}
export const WcMultiTag = ({
  inputValue,
  label,
  tagOptions,
  onTagValueChange,
  maxHeight,
  disableCloseOnSelect,
  sx,
}: WcMultiTagProps) => {
  const [tagValue, SetTagValue] = React.useState([]);
  const [options, setOptions] = React.useState<any[]>(
    tagOptions ? tagOptions : []
  );

  const handleOnTagValueChange = (input: string[]) => {
    SetTagValue(input);
    onTagValueChange(input);
  };
  React.useEffect(() => {
    if (tagOptions && tagOptions.length > 0) {
      setOptions(tagOptions);
    }
  }, [tagOptions]);

  React.useEffect(() => {
    if (inputValue && inputValue.length > 0 && options && options.length > 0) {
      const localArray = [];

      inputValue.forEach((element: string) => {
        const item = options.find((subItem: any) => subItem.id === element);
        if (item) {
          localArray.push(item);
        }
      });
      SetTagValue(localArray);
    }
  }, [options, inputValue]);

  return (
    <Stack id="WcMultiTag">
      <WcAutoComplete
        multiple
        options={options}
        sx={{...sx}}
        limitTags={7}
        disableCloseOnSelect={disableCloseOnSelect}
        getOptionLabel={(option) => option.name}
        onChange={(event, val: any[]) => handleOnTagValueChange(val)}
        value={tagValue}
        renderInput={(params) => (
          <WcTextField
            variant="filled"
            label={label}
            sx={[
              { maxHeight: maxHeight, overflow: "auto" },
              ...(Array.isArray(sx) ? sx : [sx]),
            ]}
            {...params}
          />
        )}
      />
    </Stack>
  );
};

export default WcMultiTag;
